<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Reparti </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_generico = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-row align="center" justify="center">
        <v-col cols="4">
          <v-autocomplete
            background-color="#ffffff"
            @change="filtra()"
            hide-details
            :items="sedi_lista"
            :item-text="(e) => e.des"
            item-value="id_sede"
            label="Sede"
            style="display: inline-block; max-width: 350px"
            v-model="sede_selez"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  sede_selez = '';
                  filtra();
                "
                color="primary"
                >{{ sede_selez == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
        </v-row
      >
    <v-data-table
      height="60vh"
      style="width: 40vw; margin: auto"
      :headers="headers_reparti"
      :items="lista_vista"
      fixed-header
      :key="aggiorna"
      class="elevation-1 pt-0"
    >
      <!-- Colonna del calendario settimanale -->
      <!-- <template v-slot:[`item.cal_sett`]="{ item }">
        <v-btn
          @click="
            dialog_calendario_generico = true;
            reparto_sel_id = item.id_tabella;
          "
          small
          ><v-icon color="primary">mdi-calendar</v-icon></v-btn
        >
      </template> -->

      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_spec`]="{ item }">
        <v-btn
          @click="
            dialog_calendario_specifico = true;
            reparto_sel_id = item.id_azienda_sede_reparto;
            tipo = 2
          "
          small
          ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
            >mdi-calendar-star</v-icon
          ></v-btn
        >
         </template>
        <template v-slot:[`item.sede`]="{ item }">
         <span> 
        <v-btn
          @click="
            dialog_calendario_specifico = true;
            reparto_sel_id = item.id_azienda_sede;
            tipo = 1
          "
          small
          ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
            >mdi-calendar-star</v-icon
          ></v-btn
        >{{ item.descrizione_sede }}</span>
      </template>
    </v-data-table>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico
        @click_chiudi="dialog_calendario_generico = false"
        :bottoni="true"
      />
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="
          dialog_calendario_specifico = false;
          getEccezioniLista();
        "
        :id_riferimento="reparto_sel_id"
        :tipo="tipo"
        :visibilita="dialog_calendario_specifico"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";

export default {
  name: "",

  components: { CalendarioGenerico, CalendarioSpecifico },

  props: ['id_azienda_sede_reparto'],

  data() {
    return {
      // Variabili d'appoggio
      reparto_sel_id: null,
      aggiorna: 0,
      tipo: null,
      sede_selez: "",
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,

      // Array
      headers_reparti: new Array(),
      lista_reparti: new Array(),
      lista_eccezioni: new Array(),
      sedi_lista: new Array(),
      lista_vista: [],
    };
  },

  computed: {},

  watch: {
    lista_reparti: {
      immediate: true,
      handler() {
        this.lista_vista = this.lista_reparti;
        this.filtra();
      },
    },
  },

  methods: {
    getReparti() {
      this.caricamento_dati = true;

      this.headers_reparti = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
          align: 'center',
        },
        {
          text: "Sede",
          value: "sede",
          align: 'center',
        },
        {
          text: "Nome",
          value: "descrizione",
          align: 'center',
        },
      ];

      let request = {
        controller: "schedulatore",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getaziendasedereparti",
          id_azienda: 1,
          id_azienda_sede: null,
          id_azienda_sede_reparto: this.id_azienda_sede_reparto,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.caricamento_dati = false;
        this.sedi_lista = [];
        this.lista_reparti = res.data.result ? res.data.result : [];

        this.lista_reparti.forEach((e) => {
        if(this.sedi_lista.filter((m) => m.id_sede == e.id_azienda_sede).length == 0 && e.id_azienda_sede!= null) {
              this.sedi_lista.push({
                id_sede : e.id_azienda_sede,
                des : e.descrizione_sede,
              });
              console.log(e.des_sede);
            }
        });
        /* let calendario_sett = {
          value: "cal_sett",
          text: "Calendario settimanale",
          sortable: false,
        }; */

        this.getEccezioniLista();
      });
    },

    filtra() {
      console.log("filtra");

      let items_wo_tmp = [];
      this.lista_reparti.forEach((elem) => {
        items_wo_tmp.push(elem);
      });
   
      // Filtro la sede
      if (this.sede_selez != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.id_azienda_sede == this.sede_selez) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      this.lista_vista = [];
      this.lista_vista = items_wo_tmp;
    },

    getEccezioniLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: 2,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni = res.data.calendario_ecc
            ? res.data.calendario_ecc
            : [];
          this.lista_reparti.forEach((reparto) => {
            reparto.eccezione = false;
            this.lista_eccezioni.forEach((ecc) => {
              if (reparto.id_azienda_sede_reparto == ecc.rif_calendario) {
                reparto.eccezione = true;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },
  },

  created() {},

  mounted() {
    this.getReparti();
  },
};
</script>

<style scoped>
</style>